interface RelatedContentSection {
  data: unknown[];
}

type RelatedContentSource = Record<
  string,
  RelatedContentSection | undefined
> & {
  linkedWebinars?: RelatedContentSection;
  linkedDownloads?: RelatedContentSection;
  linkedGuides?: RelatedContentSection;
};

export const getIsRelatedContentShown = (
  content: RelatedContentSource,
  keyToCheck: string
): boolean =>
  !!content.linkedWebinars?.data.length ||
  !!content.linkedDownloads?.data.length ||
  !!content.linkedGuides?.data.length ||
  !!content[keyToCheck]?.data.length;

export const getRelatedContent = (
  content: RelatedContentSource,
  keyToCheck: string
): unknown[] => [
  ...(content?.linkedWebinars?.data ?? []),
  ...(content?.linkedDownloads?.data ?? []),
  ...(content?.linkedGuides?.data ?? []),
  ...(content[keyToCheck]?.data ?? []),
];
